import { render, staticRenderFns } from "./ScoreListPage.vue?vue&type=template&id=037b3a7c"
import script from "./ScoreListPage.vue?vue&type=script&lang=js"
export * from "./ScoreListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports